
import React, { useEffect } from 'react';
import { Users, RefreshCcw, Mail } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import NewsletterSubscribersTable from '@/components/admin/NewsletterSubscribersTable';
import SendNewsletterForm from '@/components/admin/SendNewsletterForm';

interface AdminNewsletterTabProps {
  subscribers: any[];
  isLoading: boolean;
  isProcessing: boolean;
  isSending: boolean;
  onToggleStatus: (subscriber: any) => void;
  onDeleteSubscriber: (subscriber: any) => void;
  onSendNewsletter: (subject: string, content: string) => Promise<boolean>;
  onRefresh: () => void;
}

const AdminNewsletterTab: React.FC<AdminNewsletterTabProps> = ({
  subscribers,
  isLoading,
  isProcessing,
  isSending,
  onToggleStatus,
  onDeleteSubscriber,
  onSendNewsletter,
  onRefresh
}) => {
  const activeSubscribers = subscribers.filter(sub => sub.is_active);
  
  return (
    <div className="space-y-8">
      <div className="bg-white p-6 rounded-lg shadow-md">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-xl font-semibold flex items-center">
            <Users className="h-5 w-5 mr-2 text-itmgmt-blue" />
            Newsletter Subscribers ({subscribers.length})
          </h2>

          <Button variant="outline" size="sm" onClick={onRefresh}>
            <RefreshCcw className="h-4 w-4 mr-1" />
            Refresh
          </Button>
        </div>
        
        {isLoading ? (
          <div className="text-center py-8">
            <p className="text-gray-500">Loading subscribers...</p>
          </div>
        ) : subscribers.length === 0 ? (
          <div className="text-center py-8">
            <p className="text-gray-500">No subscribers found.</p>
          </div>
        ) : (
          <NewsletterSubscribersTable 
            subscribers={subscribers}
            isProcessing={isProcessing}
            onToggleStatus={onToggleStatus}
            onDeleteSubscriber={onDeleteSubscriber}
          />
        )}
      </div>

      <div className="bg-white p-6 rounded-lg shadow-md">
        <div className="flex items-center mb-6">
          <Mail className="h-5 w-5 mr-2 text-itmgmt-blue" />
          <h2 className="text-xl font-semibold">Send Newsletter</h2>
        </div>
        
        <SendNewsletterForm 
          onSendNewsletter={onSendNewsletter}
          isSending={isSending}
          subscriberCount={subscribers.length}
          activeSubscriberCount={activeSubscribers.length}
        />
      </div>
    </div>
  );
};

export default AdminNewsletterTab;
